import React from "react";
import { Text } from "basis";

import { Icon } from "../../../../components";
import {
  GATEWAY_ICON,
  SHOPIFY_SESSION_STATUS,
} from "../../../../core/constants";

const MESSAGE_MAP = {
  [SHOPIFY_SESSION_STATUS.APPROVED_ERROR]: {
    title:
      "Your payment was successful. However we couldn't contact the merchant.",
  },
  [SHOPIFY_SESSION_STATUS.FAILED_ERROR]: {
    title: "Your payment was failed. However we couldn't contact the merchant.",
  },
  [SHOPIFY_SESSION_STATUS.FAILED]: {
    title: "Oops. Your payment has been declined.",
  },
  [SHOPIFY_SESSION_STATUS.CANCELLED]: {
    title: "Oops. Your payment has been declined.",
  },
  [SHOPIFY_SESSION_STATUS.REJECTED]: {
    title: "Oops. Your payment has been declined.",
  },
  fallback: {
    title: "Unhandled error occured while processing your payment.",
  },
};

export const Header = ({ gatewayName, status, allowRetry }) => {
  const headerText = (MESSAGE_MAP[status] || MESSAGE_MAP?.fallback).title;

  return (
    <>
      <Icon type={GATEWAY_ICON[gatewayName]} size="200px" />
      <Text textStyle="heading4" margin="5 0">
        {headerText}
      </Text>
      {allowRetry && (
        <Text textStyle="subtitle2">
          You can retry or cancel the order using the buttons below.
        </Text>
      )}
      <Text textStyle="subtitle2">
        If you cancel the order, you cannot use the same payment method with
        Shopify unless you change cart or contact details.
      </Text>
    </>
  );
};
